const covers = [
  {
    href: "https://heyzine.com/flip-book/52f1efe618.html",
    src: `${process.env.PUBLIC_URL}/images/ghidromana.webp`,
    alt: "Ghid liceță RO",
  },
  {
    href: "https://heyzine.com/flip-book/357a240509.html",
    src: `${process.env.PUBLIC_URL}/images/ghidengleza.webp`,
    alt: "Ghid liceță EN",
  }, 
  {
    href: "https://heyzine.com/flip-book/aa6c0a6193.html",
    src: `${process.env.PUBLIC_URL}/images/ghidmasterromana.webp`,
    alt: "Ghid Master RO",
  },
  {
    href: "https://heyzine.com/flip-book/d7314df152.html",
    src: `${process.env.PUBLIC_URL}/images/ghidmasterengleza.webp`,
    alt: "Ghid Master EN",
  },
];

const LandingPage = () => {
  return (
    <main className="home">
      <div className="home-covers">
        {covers.map((cover) => (
          <a key={cover.alt} href={cover.href} target="_blank" rel="noreferrer">
            <img src={cover.src} alt={cover.alt} width="400" />
          </a>
        ))}
      </div>

      <section className="home-feedback">
        <h2>Feedback Ghidul Bobocului</h2>
        <p>
          Ne dorim să aflăm părerile voastre despre ghid: ce informații v-au
          fost utile și ce v-ar fi plăcut să găsiți. Formularul este anonim și
          durează doar câteva minute.
        </p>
        <a
          className="home-feedback__link"
          href="https://forms.gle/j5ZS6uxGp2wGSx6p9"
          target="_blank"
          rel="noreferrer"
        >
          Completează formularul
        </a>
      </section>
    </main>
  );
};

export default LandingPage;
